import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Grid, IconButton, InputLabel, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridActionsCellItem, GridColumnHeaderParams, GridFooter, GridFooterContainer, GridRowId, GridRowsProp } from '@mui/x-data-grid';
import { useState } from 'react';
import { CustomGridColDef, isEmpty, isNotEmpty, isNotNull } from '../../features/common/util.services';
import IButton from '../button/i-button.component';
import './i-grid.styles.scss';
import YesNoDialog from '../message-dialog/yes-no-dialog.component';
import { PAGE_SIZE } from '../../features/common/constants';
import { AddCircleOutline, CheckCircleOutline, ContentCopyRounded, North, PlayCircleOutline, South } from '@mui/icons-material';

export type GridProps = {
  title?: string;
  columns: CustomGridColDef[];
  rows: GridRowsProp;
  getRowId?: any;
  paginationModelChange?: any;
  filterModelChange?: any;
  cellDoubleClick?:any;
  onColumnHeaderClick?:any;
  cellClick?:any;
  sortModelChange?: any;
  paginationModel?: any;
  paginationType?: any;
  paginationMeta?: any;
  addRow?: any;
  showExtraText?: boolean;
  extraText?: string;
  extraTextColor?: string
  extBtnAction?: any;
  extBtnText?: any;
  extBtn2Action?: any;
  extBtn3Action?: any;
  extBtn2Text?: any;
  extBtn3Text?: any;
  addBtnText?: string;
  showAddBtn?: boolean;
  showExtBtn?:boolean;
  showExtBtn2?:boolean;
  showExtBtn3?:boolean;
  iconBtn1?: React.ComponentType<any> | any;
  iconBtn1Action?: any;
  iconBtn2Action?: any;
  iconBtn2?: React.ComponentType<any> | any;
  showAddAction?: boolean;
  showDownAction?: boolean;
  showUpAction?: boolean;
  showApproveAction?: boolean;
  showSyncAction?: boolean;
  showEditAction?: boolean;
  showDeleteAction?: boolean;
  showDuplicateAction?: boolean;
  checkboxSelection?: boolean;
  disableRowSelectionOnClick?: boolean;
  isRowSelectable?: any;
  rowSelectionModelChange?: any;
  processRowUpdate?: any;
  showAction?: boolean;
  disableMultipleRowSelection?: boolean;
  handleAddAction?: (row: any) => any;
  handleEditAction?: (row: any) => any;
  handleDeleteAction?: (row: any) => any;
  handleMoveUpAction?: (row: any) => any;
  handleMoveDownAction?: (row: any) => any;
  handleApproveAction?: (row: any) => any;
  handleDuplicateAction?: (row: any) => any;
  handleSyncAction?: (row: any) => any;
  columnGroupingModel?: any;
  apiRef?: any;
  loading?: boolean;
  totalRows?: number;
  hideFooterPagination?: boolean;
  hideFooter?: boolean;
  maxHeight?: any;
  maxWidth? : any;
  deleteMessage?: string;
  readOnly?: boolean;
}

const IGridComponent = (props: GridProps) => {
  const [row, setRow] = useState<GridRowId>(0);
  const pageModel = isNotNull(props.paginationModel) ? props.paginationModel : { page: 0, pageSize: PAGE_SIZE };
  const [paginationModel, setPaginationModel] = useState(pageModel);
  const addBtnText = props.addBtnText ? props.addBtnText : 'Add';
  const extBtnText = props.extBtnText ? props.extBtnText : 'Ext';
  const extBtn2Text = props.extBtn2Text ? props.extBtn2Text : 'Ext2';
  const extBtn3Text = props.extBtn3Text ? props.extBtn3Text : 'Ext3';
  const showAddBtn = isNotEmpty(props.showAddBtn) && props.showAddBtn !== false;
  const showExtBtn = isNotEmpty(props.showExtBtn) && props.showExtBtn !== false;
  const showExtBtn2 = isNotEmpty(props.showExtBtn2) && props.showExtBtn2 !== false;
  const showExtBtn3 = isNotEmpty(props.showExtBtn3) && props.showExtBtn3 !== false;
  const IconComponent1 = isNotEmpty(props.iconBtn1) ? props.iconBtn1 : null;
  const IconComponent2 = isNotEmpty(props.iconBtn2) ? props.iconBtn2 : null;
  const readOnly = isNotEmpty(props.readOnly) ? props.readOnly : false;
  const showEditAction = props.showEditAction !== false;
  const showDeleteAction = props.showDeleteAction !== false;
  const showApproveAction = props.showApproveAction !== false;
  const showExtraText = props.showExtraText ? props.showExtraText : false;
  const extraTextColor = props.extraTextColor ? props.extraTextColor : 'red';
  const extraText = props.extraText ? props.extraText : '';
  const paginationMode = props.paginationType ? props.paginationType : 'client';
  const hideFooter = isNotEmpty(props.hideFooter) ? props.hideFooter : false;
  const maxHeight = isEmpty(props.maxHeight) ? "70vh" : props.maxHeight;
  const maxWidth = isEmpty(props.maxWidth) ? 1400 : props.maxWidth;
  const [showMsgDialog, setShowMsgDialog] = useState(false);
  const [showMsgDialogApprove, setShowMsgDialogApprove] = useState(false);
  const [showMsgDialogDuplicate, setShowMsgDialogDuplicate] = useState(false);
  const [message] = useState((isNotNull(props.deleteMessage) ? props.deleteMessage : '') + "Do you want to delete the record?");
  const [messageApprove] = useState('Do you want to approve the data?');
  const [messageDuplicate] = useState('Do you want to duplicate the data?');
  const withActionColumn: CustomGridColDef[] = [...props.columns, {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    width: 90,
    cellClassName: 'actions',
    filterable: false,
    sortable: false,
    getActions: (row: any) => {
      return [
        showEditAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<EditIcon />}
          label="Edit"
          className="textPrimary"
          onClick={() => onEditAction(row)}
          color="secondary"
        /> : <></>,
        showDeleteAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => onDeleteAction(row)}
          color="secondary"
        /> : <></>,
        props.showAddAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<AddCircleOutline />}
          label="Add"
          onClick={() => onAddAction(row)}
          color="secondary"
        /> : <></>,
        props.showUpAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<North />}
          label="Up"
          onClick={() => onMoveUpAction(row)}
          color="secondary"
        /> : <></>,
        props.showDownAction ? <GridActionsCellItem
          sx={{ width:'10px' }}
          icon={<South />}
          label="Down"
          onClick={() => onMoveDownAction(row)}
          color="secondary"
        /> : <></>,
        showApproveAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<CheckCircleOutline />}
          label="Approve"
          onClick={() => onApproveAction(row)}
          color="secondary"
        /> : <></>,
        props.showDuplicateAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<ContentCopyRounded />}
          label="Duplicate"
          onClick={() => onDuplicateAction(row)}
          color="secondary"
      /> : <></>,
        props.showSyncAction ? <GridActionsCellItem
          sx={{ width:'15px' }}
          icon={<PlayCircleOutline />}
          label="Transfer"
          onClick={() => onSyncAction(row)}
          color="secondary"
      /> : <></>
      ];
    }
  }];

  const onMoveUpAction = (grid: any) => {
    const row = grid.row;
    if (props.handleMoveUpAction) {
      props.handleMoveUpAction(row);
    }
  }

  const onMoveDownAction = (grid: any) => {
    const row = grid.row;
    if (props.handleMoveDownAction) {
      props.handleMoveDownAction(row);
    }
  }

  const onAddAction = (grid: any) => {
    const row = grid.row;
    if (props.handleAddAction) {
      props.handleAddAction(row);
    }
  }

  const onEditAction = (grid: any) => {
    const row = grid.row;
    if (props.handleEditAction) {
      props.handleEditAction(row);
    }
  }

  const onDeleteAction = (grid: any) => {
    const row = grid.row;
    setRow(row);
    setShowMsgDialog(true);
  }

  const onOkClick = () => {
    if (props.handleDeleteAction) {
      props.handleDeleteAction(row);
    }
  }

  const onApproveAction = (grid: any) => {
    const row = grid.row;
    setRow(row);
    setShowMsgDialogApprove(true);
  }

  const onOkClickApprove = () => {
    if (props.handleApproveAction) {
      props.handleApproveAction(row);
    }
  }

  const onDuplicateAction = (grid: any) => {
    const row = grid.row;
    setRow(row);
    setShowMsgDialogDuplicate(true);
  }

  const onOkClickDuplicate = () => {
    if (props.handleDuplicateAction) {
      props.handleDuplicateAction(row);
    }
  }

  const onSyncAction = (grid: any) => {
    const row = grid.row;
    if (props.handleSyncAction) {
      props.handleSyncAction(row);
    }
  }

  function columnDesign(column: any) {
    const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
    return <div style={{ backgroundColor: 'palegreen', position: 'absolute', top: 0, left: 0, right: 0,
                         bottom: 0, display: 'flex', alignItems: 'center', padding: '8px', justifyContent: 'left' }}>
            {!column.headerIcon && <strong>{column.headerName}</strong>}
            {column.headerIcon && (<Box display="flex" alignItems="center" gap={1} justifyContent="center" sx={{ width: '100%', height: '100%' }}>
                                    {column.includeHeaderName && (<Typography variant="body2"><strong>{column.headerName}</strong></Typography>)} 
                                    <Tooltip title={column.headerIconText} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={column.headerClickAction}>{column.headerIcon}</IconButton>
                                    </Tooltip></Box>)}</div>
  }

  const getColumns = () => {
    if (props.showAction && isActionNotpresent()) {
      withActionColumn.forEach(column => {
        column.renderHeader = (params: GridColumnHeaderParams) => (columnDesign(column))
      });
      return withActionColumn;
    } else {
        props.columns.forEach(column => {
          column.renderHeader = (params: GridColumnHeaderParams) => (columnDesign(column))
        });
        return props.columns;
    }
  }

  const isActionNotpresent = () => {
    let present = false;
    props.columns.forEach(column => {
      if (column.field === 'actions') {
        present = true;
      }
    });
    return !present;
  }

  const onPaginationModelChange = (event: any) => {
    //console.log('onPaginationModelChange', event);
    if (props.paginationModelChange) {
      setPaginationModel(event);
      props.paginationModelChange(event);
    }
  }

  const onCellDoubleClick = (event: any) => {
    //console.log('onCellDoubleClick', event);
    if (props.cellDoubleClick) {
      props.cellDoubleClick(event);
    }
  }

  const onColumnHeaderClick = (event: any) => {
    //console.log('onCellDoubleClick', event);
    if (props.onColumnHeaderClick) {
      props.onColumnHeaderClick(event);
    }
  }

  const onCellClick = (event: any) => {
    //console.log('onCellDoubleClick', event);
    if (props.cellClick) {
      props.cellClick(event);
    }
  }

  const onFilterModelChange = (event: any) => {
    //console.log('onFilterModelChange', event);
    if (props.filterModelChange) {
      props.filterModelChange(event);
    }
  }

  const onSortModelChange = (event: any) => {
    //console.log('onSortModelChange', event);
    if (props.sortModelChange) {
      props.sortModelChange(event);
    }
  }

  const onRowSelectionModelChange = (event: any) => {
    //console.log('onRowSelectionModelChange', event);
    if (props.rowSelectionModelChange) {
      props.rowSelectionModelChange(event);
    }
  }

  const addRow = () => {
    if (props.addRow) {
      props.addRow();
    }
  }

  const extBtnAction = () => {
    if (props.extBtnAction) {
      props.extBtnAction();
    }
  }

  const extBtn2Action = () => {
    if (props.extBtn2Action) {
      props.extBtn2Action();
    }
  }

  const extBtn3Action = () => {
    if (props.extBtn3Action) {
      props.extBtn3Action();
    }
  }

  const iconBtn1Action = () => {
    if (props.iconBtn1Action) {
      props.iconBtn1Action();
    }
  }

  const iconBtn2Action = () => {
    if (props.iconBtn2Action) {
      props.iconBtn2Action();
    }
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    if (props.processRowUpdate) {
      props.processRowUpdate(updatedRow, originalRow);
    }
  }

  function CustomFooterComponent(props: any) {
    return (
      <GridFooterContainer sx={{ justifyContent: 'flex-end', px: 2, position: 'relative' }}>
        <div style={{ display: 'flex', gap: '20px', position: 'absolute', left: '50%', transform: 'translateX(-50%)', zIndex: 1 }}>
          {showAddBtn && <IButton className='other-btn' label={addBtnText} onActionEvent={addRow}></IButton>}
          {showExtBtn && <IButton className='other-btn' label={extBtnText} onActionEvent={extBtnAction}></IButton>}
          {showExtBtn2 && <IButton className='other-btn' label={extBtn2Text} onActionEvent={extBtn2Action}></IButton>}
          {showExtBtn3 && <IButton className='other-btn' label={extBtn3Text} onActionEvent={extBtn3Action}></IButton>}
        </div>
        <GridFooter {...props} />
      </GridFooterContainer>
    );
  }

  const renderGrid = () => {
    return <Grid container spacing={3}>
      <Grid xs={12} className='btn-panel'>
       {isNotEmpty(IconComponent1) && <IconButton onClick={iconBtn1Action} edge="end" color='secondary'>
                                        <IconComponent1 fontSize='medium'/></IconButton>}
       {isNotEmpty(IconComponent2)  && <IconButton onClick={iconBtn2Action} edge="end" color='secondary'>
                                        <IconComponent2 fontSize='medium'/></IconButton>}
       {showExtraText && <InputLabel sx={{marginLeft: 2, color: extraTextColor, fontWeight: 'bold'}}> {extraText} </InputLabel>}
      </Grid>
      <Grid xs={12}>
        <DataGrid {...props}
          initialState={{
            pagination: { paginationModel: { pageSize: PAGE_SIZE } },
          }}
          columnHeaderHeight={30}
          columnGroupingModel={props.columnGroupingModel}
          rowHeight={30}
          sx={{ maxHeight: maxHeight, maxWidth: maxWidth, marginLeft: 2, 
                '& .Mui-selected': {fontWeight: 'bold', color: 'chocolate'},
                '& .MuiDataGrid-selectedRowCount': { visibility: 'hidden'},
                pointerEvents: (readOnly ? 'none' : 'all'), opacity: (readOnly ? 0.6 : 1)
          }}
          showCellVerticalBorder={true}
          rows={props.rows}
          rowCount={props.totalRows}
          columns={getColumns()}
          apiRef={props.apiRef}
          loading={props.loading}
          checkboxSelection={props.checkboxSelection}
          disableMultipleRowSelection={props.disableMultipleRowSelection}
          isRowSelectable={props.isRowSelectable}
          disableRowSelectionOnClick={props.disableRowSelectionOnClick}
          pageSizeOptions={[100]}
          paginationModel={paginationModel}
          paginationMode={paginationMode}
          sortingMode={paginationMode}
          filterMode={paginationMode}
          onColumnHeaderClick={onColumnHeaderClick}
          onCellDoubleClick={onCellDoubleClick}
          onCellClick={onCellClick}
          onPaginationModelChange={onPaginationModelChange}
          onSortModelChange={onSortModelChange}
          onFilterModelChange={onFilterModelChange}
          onRowSelectionModelChange={onRowSelectionModelChange}
          hideFooter={hideFooter}
          disableColumnMenu
          slots={{footer: CustomFooterComponent}}
          processRowUpdate={(updatedRow, originalRow) =>
            processRowUpdate(updatedRow, originalRow)
          }
          onProcessRowUpdateError={(error) =>
            console.log(error)
          }
        />
      </Grid>
    </Grid>
  }

  return <div className="grid-panel">
    {isNotEmpty(props.title) && <div className="panel-title">{props.title}</div>}
    <div className="panel-body"> {renderGrid()} </div>
    <YesNoDialog open={showMsgDialog} onClose={() => { setShowMsgDialog(false) }} 
      onOk={() => { setShowMsgDialog(false); onOkClick(); }}
      message={message} isHorizontal={true} />
    <YesNoDialog open={showMsgDialogApprove} onClose={() => { setShowMsgDialogApprove(false) }} 
      onOk={() => { setShowMsgDialogApprove(false); onOkClickApprove(); }}
      message={messageApprove} isHorizontal={true} />
    <YesNoDialog open={showMsgDialogDuplicate} onClose={() => { setShowMsgDialogDuplicate(false) }} 
      onOk={() => { setShowMsgDialogDuplicate(false); onOkClickDuplicate(); }}
      message={messageDuplicate} isHorizontal={true} />
  </div>
}

export default IGridComponent;